import { render, staticRenderFns } from "./AutoSelectFolders.vue?vue&type=template&id=6b9bcdcf&scoped=true&"
import script from "./AutoSelectFolders.vue?vue&type=script&lang=js&"
export * from "./AutoSelectFolders.vue?vue&type=script&lang=js&"
import style0 from "./AutoSelectFolders.vue?vue&type=style&index=0&id=6b9bcdcf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9bcdcf",
  null
  
)

export default component.exports